import styled, { css } from 'styled-components';
import { MarkdownOutput } from 'react-rainbow-components';
import Badge from 'components/Badge';
import Card from 'components/Card';
import { color } from 'theme';
import {
    GREY_700, RED_500, WHITE, YELLOW_500, YELLOW_900, ORANGE_500, GREEN_600,
} from '../../../../constants';

export const WidgetContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    margin-bottom: 1rem;
`;

export const WidgetCard = styled(Card)`
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 1.5rem;
`;

export const HealthMetricsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    align-self: stretch;
    width: 100%;
    gap: 1.5rem;
`;

export const IndicatorContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0rem;
    width: auto;
    width: 280px;
    height: 180px;
    padding: 1rem 1rem 1rem 0;
    border-right: 1px solid ${color('border.divider')};
`;

export const StyledMarkdownOutput = styled(MarkdownOutput)`
    width: 100%;
    p {
        font-size: 1.25rem;
        line-height: 1.25;
    }

    em {
        color: ${RED_500};
        font-style: normal;
        font-weight: 500;
    }
`;

/** Anchored to the top-right of `WidgetCard` (card padding inset). */
export const PeriodCaption = styled.div`
    position: absolute;
    top: 1.5rem;
    right: 1.5rem;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0.25rem;
    max-width: min(45%, 22rem);
    min-width: 0;
    text-align: right;
    pointer-events: none;
`;

export const PeriodCaptionLabel = styled.span`
    font-size: 0.6875rem;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: ${color('text.label')};
`;

export const PeriodCaptionValueRow = styled.span`
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.375rem 0.5rem;
`;

export const PeriodCaptionDates = styled.span`
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 1.35;
    color: ${color('text.main')};
`;

export const PeriodCaptionDays = styled.span`
    font-size: 0.75rem;
    font-weight: 500;
    line-height: 1.25;
    color: ${color('text.label')};
    padding: 0.125rem 0.5rem;
    border-radius: 0.25rem;
    background-color: ${color('background.highlight')};
`;

export const ContentContainer = styled.div<{ $hasPeriod?: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: center;
    gap: 0.75rem;
    margin-left: 1.5rem;
    max-width: 60%;
`;

export const HealthMetricValueLine = styled.div`
    display: inline-flex;
    align-items: baseline;
    gap: 0.125rem;
    font-size: 1.375rem;
    font-weight: 700;
    color: ${GREY_700};
    line-height: 1.75rem;
    letter-spacing: -0.01em;
`;

export const StyledBadge = styled(Badge)`
    ${(props) => props.variant === 'default' && css`
        color: ${YELLOW_900};
        background-color: ${YELLOW_500};
        font-size: 0.625rem;
        text-transform: uppercase;
        border: none;
    `}

    ${(props) => props.variant === 'error' && css`
        color: ${WHITE};
        background-color: ${RED_500};
        font-size: 0.625rem;
        text-transform: uppercase;
        border: none;
    `}

    ${(props) => props.variant === 'warning' && css`
        color: ${WHITE};
        background-color: ${ORANGE_500};
        font-size: 0.625rem;
        text-transform: uppercase;
        border: none;
    `}

    ${(props) => props.variant === 'success' && css`
        color: ${WHITE};
        background-color: ${GREEN_600};
        font-size: 0.625rem;
        text-transform: uppercase;
        border: none;
    `}
`;

export const ValueContainer = styled.div`
    display: flex;
    gap: 0.5rem;
    width: 100%;
    align-items: center;
    justify-content: center;
`;
